// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/organization_events.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Organization } from "./organization_pb.js";
import { file_core_v1_organization } from "./organization_pb.js";
import type { ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/organization_events.proto.
 */
export const file_core_v1_organization_events: GenFile = /*@__PURE__*/
  fileDesc("CiFjb3JlL3YxL29yZ2FuaXphdGlvbl9ldmVudHMucHJvdG8SB2NvcmUudjEi3QMKEU9yZ2FuaXphdGlvbkV2ZW50EjQKB2NyZWF0ZWQYASABKAsyIS5jb3JlLnYxLk9yZ2FuaXphdGlvbkNyZWF0ZWRFdmVudEgAEjQKB3VwZGF0ZWQYAiABKAsyIS5jb3JlLnYxLk9yZ2FuaXphdGlvblVwZGF0ZWRFdmVudEgAEjQKB2RlbGV0ZWQYAyABKAsyIS5jb3JlLnYxLk9yZ2FuaXphdGlvbkRlbGV0ZWRFdmVudEgAEjwKC3Byb3Zpc2lvbmVkGAQgASgLMiUuY29yZS52MS5Pcmdhbml6YXRpb25Qcm92aXNpb25lZEV2ZW50SAASSwoTZW50aXRsZW1lbnRfZ3JhbnRlZBgFIAEoCzIsLmNvcmUudjEuT3JnYW5pemF0aW9uRW50aXRsZW1lbnRHcmFudGVkRXZlbnRIABJLChNlbnRpdGxlbWVudF9yZXZva2VkGAYgASgLMiwuY29yZS52MS5Pcmdhbml6YXRpb25FbnRpdGxlbWVudFJldm9rZWRFdmVudEgAEkUKEHNpZ251cF9jb21wbGV0ZWQYByABKAsyKS5jb3JlLnYxLk9yZ2FuaXphdGlvblNpZ251cENvbXBsZXRlZEV2ZW50SABCBwoFZXZlbnQiRwoYT3JnYW5pemF0aW9uQ3JlYXRlZEV2ZW50EisKDG9yZ2FuaXphdGlvbhgBIAEoCzIVLmNvcmUudjEuT3JnYW5pemF0aW9uIoUBChhPcmdhbml6YXRpb25VcGRhdGVkRXZlbnQSNAoVcHJldmlvdXNfb3JnYW5pemF0aW9uGAEgASgLMhUuY29yZS52MS5Pcmdhbml6YXRpb24SMwoUdXBkYXRlZF9vcmdhbml6YXRpb24YAiABKAsyFS5jb3JlLnYxLk9yZ2FuaXphdGlvbiJHChhPcmdhbml6YXRpb25EZWxldGVkRXZlbnQSKwoMb3JnYW5pemF0aW9uGAEgASgLMhUuY29yZS52MS5Pcmdhbml6YXRpb24iZwocT3JnYW5pemF0aW9uUHJvdmlzaW9uZWRFdmVudBIrCgxvcmdhbml6YXRpb24YASABKAsyFS5jb3JlLnYxLk9yZ2FuaXphdGlvbhIaCgd1c2VyX2lkGAIgASgLMgkudHlwZXMuSUQiZwojT3JnYW5pemF0aW9uRW50aXRsZW1lbnRHcmFudGVkRXZlbnQSKwoMb3JnYW5pemF0aW9uGAEgASgLMhUuY29yZS52MS5Pcmdhbml6YXRpb24SEwoLZW50aXRsZW1lbnQYAiABKAkiZwojT3JnYW5pemF0aW9uRW50aXRsZW1lbnRSZXZva2VkRXZlbnQSKwoMb3JnYW5pemF0aW9uGAEgASgLMhUuY29yZS52MS5Pcmdhbml6YXRpb24SEwoLZW50aXRsZW1lbnQYAiABKAkiiwEKIE9yZ2FuaXphdGlvblNpZ251cENvbXBsZXRlZEV2ZW50EisKDG9yZ2FuaXphdGlvbhgBIAEoCzIVLmNvcmUudjEuT3JnYW5pemF0aW9uEhoKB3VzZXJfaWQYAiABKAsyCS50eXBlcy5JRBIeCgtmYWNpbGl0eV9pZBgDIAEoCzIJLnR5cGVzLklEQi1aK3BhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWNvcmUvYXBpL3YxO2NvcmVfdjFiCGVkaXRpb25zcOgH", [file_core_v1_organization, file_types]);

/**
 * @generated from message core.v1.OrganizationEvent
 */
export type OrganizationEvent = Message<"core.v1.OrganizationEvent"> & {
  /**
   * @generated from oneof core.v1.OrganizationEvent.event
   */
  event: {
    /**
     * @generated from field: core.v1.OrganizationCreatedEvent created = 1;
     */
    value: OrganizationCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: core.v1.OrganizationUpdatedEvent updated = 2;
     */
    value: OrganizationUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: core.v1.OrganizationDeletedEvent deleted = 3;
     */
    value: OrganizationDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: core.v1.OrganizationProvisionedEvent provisioned = 4;
     */
    value: OrganizationProvisionedEvent;
    case: "provisioned";
  } | {
    /**
     * @generated from field: core.v1.OrganizationEntitlementGrantedEvent entitlement_granted = 5;
     */
    value: OrganizationEntitlementGrantedEvent;
    case: "entitlementGranted";
  } | {
    /**
     * @generated from field: core.v1.OrganizationEntitlementRevokedEvent entitlement_revoked = 6;
     */
    value: OrganizationEntitlementRevokedEvent;
    case: "entitlementRevoked";
  } | {
    /**
     * @generated from field: core.v1.OrganizationSignupCompletedEvent signup_completed = 7;
     */
    value: OrganizationSignupCompletedEvent;
    case: "signupCompleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message core.v1.OrganizationEvent.
 * Use `create(OrganizationEventSchema)` to create a new message.
 */
export const OrganizationEventSchema: GenMessage<OrganizationEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 0);

/**
 * @generated from message core.v1.OrganizationCreatedEvent
 */
export type OrganizationCreatedEvent = Message<"core.v1.OrganizationCreatedEvent"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.OrganizationCreatedEvent.
 * Use `create(OrganizationCreatedEventSchema)` to create a new message.
 */
export const OrganizationCreatedEventSchema: GenMessage<OrganizationCreatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 1);

/**
 * @generated from message core.v1.OrganizationUpdatedEvent
 */
export type OrganizationUpdatedEvent = Message<"core.v1.OrganizationUpdatedEvent"> & {
  /**
   * @generated from field: core.v1.Organization previous_organization = 1;
   */
  previousOrganization?: Organization;

  /**
   * @generated from field: core.v1.Organization updated_organization = 2;
   */
  updatedOrganization?: Organization;
};

/**
 * Describes the message core.v1.OrganizationUpdatedEvent.
 * Use `create(OrganizationUpdatedEventSchema)` to create a new message.
 */
export const OrganizationUpdatedEventSchema: GenMessage<OrganizationUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 2);

/**
 * @generated from message core.v1.OrganizationDeletedEvent
 */
export type OrganizationDeletedEvent = Message<"core.v1.OrganizationDeletedEvent"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message core.v1.OrganizationDeletedEvent.
 * Use `create(OrganizationDeletedEventSchema)` to create a new message.
 */
export const OrganizationDeletedEventSchema: GenMessage<OrganizationDeletedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 3);

/**
 * @generated from message core.v1.OrganizationProvisionedEvent
 */
export type OrganizationProvisionedEvent = Message<"core.v1.OrganizationProvisionedEvent"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * The user who created the organization during signup
   *
   * @generated from field: types.ID user_id = 2;
   */
  userId?: ID;
};

/**
 * Describes the message core.v1.OrganizationProvisionedEvent.
 * Use `create(OrganizationProvisionedEventSchema)` to create a new message.
 */
export const OrganizationProvisionedEventSchema: GenMessage<OrganizationProvisionedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 4);

/**
 * @generated from message core.v1.OrganizationEntitlementGrantedEvent
 */
export type OrganizationEntitlementGrantedEvent = Message<"core.v1.OrganizationEntitlementGrantedEvent"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * @generated from field: string entitlement = 2;
   */
  entitlement: string;
};

/**
 * Describes the message core.v1.OrganizationEntitlementGrantedEvent.
 * Use `create(OrganizationEntitlementGrantedEventSchema)` to create a new message.
 */
export const OrganizationEntitlementGrantedEventSchema: GenMessage<OrganizationEntitlementGrantedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 5);

/**
 * @generated from message core.v1.OrganizationEntitlementRevokedEvent
 */
export type OrganizationEntitlementRevokedEvent = Message<"core.v1.OrganizationEntitlementRevokedEvent"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * @generated from field: string entitlement = 2;
   */
  entitlement: string;
};

/**
 * Describes the message core.v1.OrganizationEntitlementRevokedEvent.
 * Use `create(OrganizationEntitlementRevokedEventSchema)` to create a new message.
 */
export const OrganizationEntitlementRevokedEventSchema: GenMessage<OrganizationEntitlementRevokedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 6);

/**
 * @generated from message core.v1.OrganizationSignupCompletedEvent
 */
export type OrganizationSignupCompletedEvent = Message<"core.v1.OrganizationSignupCompletedEvent"> & {
  /**
   * @generated from field: core.v1.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * The newly created user during signup
   *
   * @generated from field: types.ID user_id = 2;
   */
  userId?: ID;

  /**
   * The default facility created during signup
   *
   * @generated from field: types.ID facility_id = 3;
   */
  facilityId?: ID;
};

/**
 * Describes the message core.v1.OrganizationSignupCompletedEvent.
 * Use `create(OrganizationSignupCompletedEventSchema)` to create a new message.
 */
export const OrganizationSignupCompletedEventSchema: GenMessage<OrganizationSignupCompletedEvent> = /*@__PURE__*/
  messageDesc(file_core_v1_organization_events, 7);

